import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { hmrBootstrap } from '../hmr';
import { environment } from './environments/environment';

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.production) {
	enableProdMode();
	bootstrap();
} else {
	if (module['hot']) {
		hmrBootstrap(module, bootstrap);
	} else {
		bootstrap();
	}
}
